import * as React from 'react';
import { IAdvancedRichText } from '../../../../../../../inputs/rich-text-advanced/IAdvancedRichText';
import { RichTextAdvancedRender } from '../../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { OptionsGroupDividerLabel } from './OptionsGroupDividerLabel';

export interface IOptionsGroupRichTextAdvancedDividerLabelRenderProps {
  text?: IAdvancedRichText;
}

/**
 * Renderizza il testo avanzato e lo stile del Divider (Label)
 */
export function OptionsGroupRichTextAdvancedDividerLabelRender(
  props: IOptionsGroupRichTextAdvancedDividerLabelRenderProps,
) {
  if (!props.text) return null;

  return (
    <OptionsGroupDividerLabel>
      <RichTextAdvancedRender inline text={props.text} />
    </OptionsGroupDividerLabel>
  );
}
